module.exports = __webpack_public_path__ + "static/media/trashbag.303a6787.svg";